import React from 'react';
import { DataRow } from '../../services/analytics';

interface DataTableProps {
  rows: DataRow[];
  columns: string[];
}

const DataTable: React.FC<DataTableProps> = ({ rows, columns }) => {
  const visibleRows = rows.slice(0, 100);

  return (
    <div className="premium-card" style={{ overflow: 'hidden' }}>
      <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid var(--border-color)', display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
        <div>
          <h3 style={{ fontSize: '1.125rem', marginBottom: '0.25rem' }}>Data Table</h3>
          <p style={{ margin: 0, fontSize: '0.875rem' }}>Showing {visibleRows.length.toLocaleString()} of {rows.length.toLocaleString()} matching rows.</p>
        </div>
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column} style={headerCellStyle}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {visibleRows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((column) => (
                  <td key={column} style={bodyCellStyle}>{formatCell(row[column])}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {rows.length === 0 && (
        <p style={{ padding: '1.5rem', margin: 0, fontSize: '0.875rem' }}>No rows match the current filters.</p>
      )}
    </div>
  );
};

const headerCellStyle: React.CSSProperties = {
  padding: '0.875rem 1rem',
  borderBottom: '1px solid var(--border-color)',
  color: 'var(--text-muted)',
  fontSize: '0.75rem',
  fontWeight: 700,
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
};

const bodyCellStyle: React.CSSProperties = {
  padding: '0.875rem 1rem',
  borderBottom: '1px solid var(--border-color)',
  color: 'var(--text-secondary)',
  fontSize: '0.875rem',
  whiteSpace: 'nowrap',
};

const formatCell = (value: DataRow[string]) => {
  if (value === null || value === undefined) return '';
  return String(value);
};

export default DataTable;
